import { useContext, useEffect, useState } from 'react';
import { NextPage } from 'next';

import ListCollection from 'types/redux/ListCollection';

import Article,  { Roles } from 'models/Article';

import { LIST_MARKUP } from 'consts/redux';
import { selectCmsPageSection } from 'utils/locale';

import { list as listArticles } from 'requests/articles';

import LocaleContext from 'components/context/Locale';
import Head from 'components/layout/Head';
import PageContainer from 'components/layout/PageContainer';
import LayoutDefault from 'components/modules/public/layouts/Default';

import Articles from './sections/Articles';
import SectionHero from './sections/Hero';
import SectionNewsletter from './sections/Newsletter';
import Search from './sections/Search';
import StyledComponent from './styles';
import { Props, SearchOverrides, ValuesTypes } from './types';

const PublicPageCategoryArticlesEmployee: NextPage<Props> = ({ articles, articleCategories, cmsPage }) => {
    const [articlesList, setArticlesList]: [ListCollection<Article>, Function] = useState(articles);
    const [values, setValues]: [ValuesTypes, Function] = useState({
        role: Roles.Worker,
        categorySlug: null,
    });
    const onSearch = (overrides: SearchOverrides | {} = {}) => {
        setArticlesList({
            ...LIST_MARKUP,
            isLoading: true,
            isLoaded: false,
        });

        listArticles({
            page: 1,
            perPage: 6,
            ...values,
            ...overrides,
        })
            .then(listCollection => {
                setArticlesList({
                    ...LIST_MARKUP,
                    ...listCollection,
                });
            })
            .catch(error => {
                console.error(error);
                setArticlesList({
                    ...LIST_MARKUP,
                    isLoading: false,
                    isLoaded: false,
                    error: true,
                });
            });
    };
    useEffect(() => {
        const categorySlug = articles?.elements[0]?.category?.slug;

        if (categorySlug) {
            setValues({
                categorySlug,
            });
            onSearch({
                categorySlug,
            });
        }
    }, []);
    const localeContext = useContext(LocaleContext);
    const data = localeContext?.translations?.articlesEmployeeCategories;
    return (
        <StyledComponent className="public-page-articlesemployee">
            <Head
                {...data.meta}
                title={cmsPage?.metaTitle || data?.meta?.title}
                description={cmsPage?.metaDescription || data?.meta?.description}
                robots={cmsPage?.metaRobots}
                image={cmsPage?.image?.imageUrl || data?.meta?.image}
            />
            <LayoutDefault>
                <PageContainer>
                    <SectionHero
                        translations={{
                            ...data.content.hero,
                            ...selectCmsPageSection(cmsPage, 'hero'),
                        }}
                        articleCategories={articleCategories}
                    />
                    <Search
                        translations={{
                            ...data.content.form,
                            ...selectCmsPageSection(cmsPage, 'form'),
                        }}
                        articleCategories={articleCategories}
                    />
                    {Array.isArray(articlesList?.elements) && articlesList?.elements.length > 0 && (
                        <Articles
                            translations={{
                                ...data.content.sectionArticlesProps,
                                ...selectCmsPageSection(cmsPage, 'sectionarticlesprops'),
                            }}
                            articles={articlesList.elements}
                            meta={articlesList.meta}
                            onSearch={onSearch}
                        />
                    )}
                    <SectionNewsletter
                        translations={{
                            ...data.content.newsletter,
                            ...selectCmsPageSection(cmsPage, 'newsletter'),
                        }}
                    />
                </PageContainer>
            </LayoutDefault>
        </StyledComponent>
    );
};

export default PublicPageCategoryArticlesEmployee;
